import React from "react";
import { useSelector } from "react-redux";
import { ShieldOff } from "lucide-react";

import { UIEmptyState } from "../../../components/ui";
import messages from "../../../assets/locale/messages";

import "./NoPermission.scss";

const NoPermission = () => {
  const lang = useSelector((state) => state.locale.lang);
  const { shared } = messages[lang];

  return (
    <div className="no-permission">
      <UIEmptyState
        title={shared.noHavePermission}
        icon={<ShieldOff aria-hidden />}
        classNames={{ root: "no-permission__empty-state" }}
      />
    </div>
  );
};

export default NoPermission;
